import * as React from 'react';

import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import {useGetUserNames} from '../../../lead/sales-documents/shared/graphql/hooks';

import {QUOTE_STATUS_OPTIONS, INVOICE_STATUS_OPTIONS} from './helper';

import styles from './quote-filters.module.css';

type Props = {
    activeFilters: FilterObject[];
    onUpdateFilters: (arg1: FilterObject) => void;
    isAdmin: boolean | null | undefined;
    variant?: 'quote' | 'invoice';
};

export function QuoteFilters(props: Props) {
    const {variant = 'quote'} = props;

    const currentStatus = safelyGetFilterByKey(props.activeFilters, 'status');
    const currentOwner = safelyGetFilterByKey(props.activeFilters, 'owner');

    const {users} = useGetUserNames(false);

    const ownerOptions = React.useMemo(() => {
        if (!users) return [];

        const options = [
            {
                value: null,
                label: 'Unassigned',
            },
            ...users.edges.map((user) => ({
                value: user.node.id,
                label: user.node.name,
            })),
        ];

        return options;
    }, [users]);

    return (
        <StackLegacy isHorizontal={true} spacing={16}>
            <div className={styles['status-filter']}>
                <SelectPickerGeneric
                    options={variant === 'quote' ? QUOTE_STATUS_OPTIONS : INVOICE_STATUS_OPTIONS}
                    value={
                        variant === 'quote'
                            ? QUOTE_STATUS_OPTIONS.find((opt) => opt.value === currentStatus)
                            : INVOICE_STATUS_OPTIONS.find((opt) => opt.value === currentStatus)
                    }
                    // @ts-expect-error
                    onChange={(newStatus) => {
                        props.onUpdateFilters({
                            ...props.activeFilters[0],
                            status: newStatus.value,
                        });
                    }}
                    onClear={() => {
                        props.onUpdateFilters({
                            ...props.activeFilters[0],
                            status: null,
                        });
                    }}
                    isSearchable={false}
                    placeholder='Status...'
                />
            </div>
            {props.isAdmin && (
                <div className={styles['status-filter']}>
                    <SelectPickerGeneric
                        options={ownerOptions}
                        value={ownerOptions.find((opt) => opt.value === currentOwner)}
                        // @ts-expect-error
                        onChange={(newOwner) => {
                            props.onUpdateFilters({...props.activeFilters[0], owner: newOwner});
                        }}
                        onClear={() => {
                            props.onUpdateFilters({
                                ...props.activeFilters[0],
                                owner: [],
                            });
                        }}
                        isSearchable={true}
                        placeholder='Owner...'
                    />
                </div>
            )}
        </StackLegacy>
    );
}
